import { cloneElement, isValidElement } from "react";
import { useAbsolute } from "./Absolute.hooks";
import type { AbsoluteProps } from "./Absolute.types";

/**
 * children 요소를 `to` props로 전달받은 요소를 기준으로 띄우는 역할입니다.
 *
 * 기본 position 이 `absolute` 로 설정되어 있어, 부모 요소에 영향을 받습니다.
 *
 * 만약 부모 요소와 관계 없이 화면에서 자유롭게 위치를 설정하고 싶다면, `Portal.Absolute` 또는 `Portal`과 함께 사용해주세요
 *
 * > Docs의 예시는 ref가 깨져서 `show code` 용으로만 확인해주시면 됩니다.
 */
export const Absolute = ({
  to,
  children,
  position = "bottom",
  align = "start",
  offsetX = "0px",
  offsetY = "0px",
  autoMinWidth = false,
}: AbsoluteProps) => {
  const floatStyle = useAbsolute({ to, position, align });

  if (!floatStyle || !isValidElement<HTMLElement>(children)) return null;

  const floated = cloneElement(children, {
    style: {
      ...children.props.style,
      position: "fixed",
      minWidth: autoMinWidth ? "auto" : "max-content",
      top: "0",
      left: "0",
      zIndex: "var(--clay-zIndex-modal)",
      transform: `translate(calc(${floatStyle.computedX} + ${offsetX}), calc(${floatStyle.computedY} + ${offsetY}))`,
    },
  });

  return floated;
};
